import { useQuery } from '@tanstack/react-query';

import { PharmacyService } from '@/services/pharmacy.service';
import type { PharmacyProductInventory } from '@montugroup/circuit-shared/types/index';

export const INVENTORY_PRODUCTS_QUERY_KEY = 'products';

const useGetInventoryProducts = (pharmacyId: number | null) => {
  const fetchProducts = async () => {
    if (!pharmacyId) {
      return { products: [], inventoryStatusList: [] };
    }
    // Fetch products using the new method
    const pharmacyInventoryResponse = await PharmacyService.getPharmacyProductInventory(pharmacyId);

    const productsUpdated = pharmacyInventoryResponse.data.data.map((product: PharmacyProductInventory) => {
      if (!product.active) {
        return { ...product, name: `${product.name} - (Inactive)` };
      }
      return product;
    });

    return {
      products: productsUpdated,
    };
  };

  const { isLoading, error, data, refetch, isError } = useQuery({
    queryKey: [INVENTORY_PRODUCTS_QUERY_KEY, pharmacyId],
    queryFn: fetchProducts,
    meta: {
      error: {
        message: 'Error fetching products',
        showToast: true,
      },
    },
  });

  return {
    products: data?.products || [],
    isLoading,
    error,
    isError,
    refetch,
  };
};

export default useGetInventoryProducts;
